import { useEffect } from "react"
import { loadScript } from "../utils/loadScripts"
import Footer from "./Footer"
import Header from "./Header"

function Services() {

    useEffect(() => {
        const init = async () => {
            await loadScript("/assets/js/plugins/jquery.min.js")
            await loadScript("/assets/js/plugins/swup.min.js")
            await loadScript("/assets/js/plugins/swiper.min.js")
            await loadScript("/assets/js/plugins/fancybox.min.js")
            await loadScript("/assets/js/plugins/gsap.min.js")
            await loadScript("/assets/js/plugins/smooth-scroll.js")
            await loadScript("/assets/js/plugins/ScrollTrigger.min.js")
            await loadScript("/assets/js/plugins/ScrollTo.min.js")

            await loadScript("assets/js/main.js")
        }

        init()

    }, [])
    return (
        <>
            <div id="swup">

                <Header />
                <div id="swupMain" className="mil-main-transition">

                    {/* <!-- banner --> */}
                    <div className="mil-dark-bg">
                        <div className="mil-inner-banner">
                            <div className="mi-invert-fix">
                                <div className="mil-banner-content mil-up">
                                    <div className="mil-animation-frame">
                                        <div className="mil-animation mil-position-4 mil-scale" data-value-1="6" data-value-2="1.4"></div>
                                    </div>
                                    <div className="container">
                                        <ul className="mil-breadcrumbs mil-light mil-mb-60">
                                            <li><a href="/">Home</a></li>
                                            <li><a href="/services">Services</a></li>
                                        </ul>
                                        <h1 className="mil-muted mil-mb-60">This is <span className="mil-thin">what</span><br /> we do <span className="mil-thin">best</span></h1>
                                        <a href="#services" className="mil-link mil-accent mil-arrow-place mil-down-arrow">
                                            <span>Our services</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- banner end -->

                    <!-- services --> */}
                        <section id="services">
                            <div className="mi-invert-fix">
                                <div className="container mil-p-120-60">
                                    <div className="row">
                                        <div className="col-lg-5">

                                            <div className="mil-lines-place mil-light"></div>

                                        </div>
                                        <div className="col-lg-7">
                                            <div className="row">
                                                <div className="col-md-6 col-lg-6">
                                                    <a href="/branding" className="mil-service-card-lg mil-more mil-accent-cursor mil-offset">
                                                        <h4 className="mil-muted mil-up mil-mb-30">Branding & <br />Identity Design</h4>
                                                        <p className="mil-descr mil-light-soft mil-up mil-mb-30">Creating impactful brand identities that express purpose, evoke emotion, and establish strong, memorable long-term market distinction.</p>
                                                        <ul className="mil-service-list mil-light mil-mb-30">
                                                            <li className="mil-up">Brand Strategy & Positioning</li>
                                                            <li className="mil-up">Logo Design & Visual Identity</li>
                                                            <li className="mil-up">Brand Guidelines & Playbooks</li>
                                                            <li className="mil-up">Packaging & Label Design</li>
                                                            <li className="mil-up">Rebranding & Brand Refresh </li>
                                                            <li className="mil-up">Naming & Brand Architecture </li>
                                                        </ul>
                                                        <div className="mil-link mil-accent mil-arrow-place mil-up">
                                                            <span>Read more</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <a href="/campaigns" className="mil-service-card-lg mil-more mil-accent-cursor">
                                                        <h4 className="mil-muted mil-up mil-mb-30">Creative Advertising & Campaigns</h4>
                                                        <p className="mil-descr mil-light-soft mil-up mil-mb-30">Building compelling multi-channel campaigns that spark attention, drive engagement, and influence customer behaviour.</p>
                                                        <ul className="mil-service-list mil-light mil-mb-30">
                                                            <li className="mil-up">Creative Concept Development </li>
                                                            <li className="mil-up">Integrated Advertising Campaigns </li>
                                                            <li className="mil-up">Print & Outdoor Advertising </li>
                                                            <li className="mil-up">Brand Films & Video Content</li>
                                                            <li className="mil-up">Event & Experiential Creative </li>
                                                            <li className="mil-up">Content & Copywriting </li>
                                                        </ul>
                                                        <div className="mil-link mil-accent mil-arrow-place mil-up">
                                                            <span>Read more</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <a href="/digitalmarketing" className="mil-service-card-lg mil-more mil-accent-cursor mil-offset">
                                                        <h4 className="mil-muted mil-up mil-mb-30">Digital Marketing & <br />Performance Growth</h4>
                                                        <p className="mil-descr mil-light-soft mil-up mil-mb-30">Driving measurable growth through targeted digital strategies, content, and performance-focused marketing solutions.</p>
                                                        <ul className="mil-service-list mil-light mil-mb-30">
                                                            <li className="mil-up">Social Media Marketing & Management </li>
                                                            <li className="mil-up">Performance Marketing & Paid Media </li>
                                                            <li className="mil-up">Search Engine Optimization(SEO)</li>
                                                            <li className="mil-up">Content Marketing Strategy</li>
                                                            <li className="mil-up">Email & Marketing Automation </li>
                                                            <li className="mil-up">Analytics, Insights & Optimization</li>
                                                        </ul>
                                                        <div className="mil-link mil-accent mil-arrow-place mil-up">
                                                            <span>Read more</span>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <a href="/uiux" className="mil-service-card-lg mil-more mil-accent-cursor">
                                                        <h4 className="mil-muted mil-up mil-mb-30">Web, UI/UX & <br />Digital Experiences</h4>
                                                        <p className="mil-descr mil-light-soft mil-up mil-mb-30">Designing intuitive digital experiences that enhance brand presence and convert audience interactions effectively.</p>
                                                        <ul className="mil-service-list mil-light mil-mb-30">
                                                            <li className="mil-up">Website Strategy & Information Architecture</li>
                                                            <li className="mil-up">UI/UX Design </li>
                                                            <li className="mil-up">Website Design & Development </li>
                                                            <li className="mil-up">E-Commerce Experiences</li>
                                                            <li className="mil-up">Mobile App UI/UX Design </li>
                                                            <li className="mil-up">Digital Product & Experience Design </li>
                                                        </ul>
                                                        <div className="mil-link mil-accent mil-arrow-place mil-up">
                                                            <span>Read more</span>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    {/* <!-- services end -->

                <!-- call to action --> */}
                    <section className="mil-soft-bg">
                        <div className="container mil-p-120-120">
                            <div className="row">
                                <div className="col-lg-10">

                                    <span className="mil-suptitle mil-suptitle-right mil-suptitle-dark mil-up">Looking to make your mark? We'll help you turn <br /> your project into a success story.</span>

                                </div>
                            </div>
                            <div className="mil-center">
                                <h2 className="mil-up mil-mb-60">Let’s make an <span className="mil-thin">impact</span><br /> together. Ready <span className="mil-thin">when you are</span></h2>
                                <div className="mil-up"><a href="/contact" className="mil-button mil-arrow-place"><span>Contact us</span></a></div>
                            </div>
                        </div>
                    </section>
                    {/* <!-- call to action end --> */}


                </div>
                <Footer />

            </div>

        </>
    )
}

export default Services